// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vLgt","left":"styles_left__1IeES","right":"styles_right___q3TY","alert":"styles_alert__sBYZB"};